<template>
  <div v-show="getAuthWithRouter">
    <Header />
    <form-wizard
      next-button-text="Siguiente"
      back-button-text="Atrás"
      finish-button-text="Guardar"
      title="PRODUCTOS"
      subtitle="Gestiona tus productos fácil y simple"
      color="#009db0"
      @on-complete="onComplete"
    >
      <tab-content title="Producto">
        <div class="container">
          <b-form-group
            class="item-container"
            id="input-group-1"
            label="Nombre:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="product.name"
              type="text"
              placeholder="Ingrese el nombre de producto"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            class="item-container"
            id="input-group-2"
            label="Descripción:"
            label-for="input-2"
          >
            <b-form-textarea
              id="input-2"
              v-model="product.description"
              type="text"
              placeholder="Ingrese descripción del producto"
              required
            ></b-form-textarea>
          </b-form-group>

          <b-form-group
            class="item-container"
            id="input-group-3"
            label="Categoria:"
            label-for="input-3"
          >
            <b-form-select
              id="input-3"
              v-model="product.category"
              :options="getCategories()"
              required
            ></b-form-select>
          </b-form-group>

          <div class="item-container custom-control custom-switch sale-input">
            <input
              v-model="product.important"
              type="checkbox"
              class="custom-control-input"
              id="customSwitches"
            />
            <label class="custom-control-label" for="customSwitches"
              >Es un producto destacado?</label
            >
          </div>
          <div class="item-container custom-control custom-switch sale-input">
            <input
              v-model="product.enable"
              type="checkbox"
              class="custom-control-input"
              id="customSwitches"
            />
            <label class="custom-control-label" for="customSwitches"
              >Esta habilitado?</label
            >
          </div>
        </div>
      </tab-content>
      <tab-content title="Modelos">
        <div class="container">
          <div
            v-for="(option, index) in product.options"
            :key="index"
            class="options-container"
          >
            <div class="header-container">
              <div @click="removeOption(index)" class="remove-option">
                <img
                  src="../assets/delete.svg"
                  width="25px"
                  height="25px"
                  title="Borrar Modelo"
                />
              </div>
              <div @click="showOption(index)" class="header-option">
                <h5 class="option-name">
                  {{ option.name !== "" ? option.name : "Crear nuevo modelo" }}
                </h5>
                <img
                  v-if="currentOptionIndex === index"
                  src="../assets/ArrowUp.png"
                  width="35px"
                  height="35px"
                />
                <img
                  v-else
                  src="../assets/ArrowDown.png"
                  width="35px"
                  height="35px"
                />
              </div>
            </div>
            <div class="form-container" v-if="currentOptionIndex === index">
              <b-form-group
                id="input-group-1"
                label="Nombre del diseño:"
                label-for="input-1"
                class="item-container"
              >
                <b-form-input
                  id="input-1"
                  v-model="option.name"
                  type="text"
                  placeholder="Ingrese el nombre del diseño"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-4"
                label="Precio del diseño:"
                label-for="input-4"
                class="item-container"
              >
                <b-form-input
                  id="input-4"
                  v-model="option.price"
                  type="number"
                  placeholder="Ingrese precio del diseño"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-5"
                label="Stock:"
                label-for="input-5"
                class="item-container"
              >
                <b-form-input
                  id="input-5"
                  v-model="option.stock"
                  type="number"
                  placeholder="Ingrese stock inicial del producto"
                  required
                ></b-form-input>
              </b-form-group>

              <input
                class="itemForm-image"
                type="file"
                @change.prevent="onFileSelected"
              />

              <div class="galery">
                <img
                  v-for="(image, index) in option.images"
                  :key="index"
                  class="image"
                  width="90px"
                  height="90px"
                  :src="image.url"
                  @click="deleteImage(index)"
                />
              </div>
            </div>
          </div>
          <ButtonComponent text="Nuevo Modelo" @onClick="addOption()" />
        </div>
      </tab-content>
      <!-- <tab-content title="Verificación"> Verificación </tab-content> -->
    </form-wizard>
  </div>
</template>

<script>
import firebase from "firebase/firebase";
import "firebase/storage";
import { db } from "../firebase";
import user_detection from "../mixins/user_detection";
import ButtonComponent from "../components/ButtonComponent";
import Header from "../components/Header";

export default {
  mixins: [user_detection],
  name: "News",
  firebase: {
    products: db.ref("products"),
    categories: db.ref("categories"),
  },
  data() {
    return {
      products: [],
      categories: [],
      product: {
        code: 0,
        name: "",
        description: "",
        category: "Seleccione una categoria",
        enable: true,
        important: false,
        options: [
          {
            name: "",
            stock: 0,
            price: "",
            images: [],
          },
        ],
      },
      selectedFile: null,
      currentOptionIndex: -1,
      prodKey: undefined,
    };
  },
  mounted() {
    this.getProduct();
    this.isUserAdmin();
  },
  computed: {},
  methods: {
    onComplete() {
      let optionsTemp = [];
      this.product.options.forEach((element) => {
        if (element.name !== "" && element.price !== "") {
          optionsTemp.push(element);
        }
      });
      this.product.options = optionsTemp;

      if (this.product.code === 1) {
        this.product.code = this.products.length + 1;
      }

      if (this.prodKey === undefined) {
        db.ref("products").push(this.product);
      } else {
        db.ref("products/" + this.prodKey).update(this.product);
      }
      this.$router.replace(`Product?c=${this.product.code}`);
    },
    getProduct() {
      this.prodKey = this.$route.query.k;

      if (this.prodKey !== undefined && this.prodKey !== null) {
        const t = this;
        db.ref(`products/${this.prodKey}`)
          .once("value")
          .then(function (snapshot) {
            var prod = snapshot.val();
            if (prod !== undefined && prod !== null) {
              t.product = prod;
            }
          });
      } else {
        this.product.code = this.products.length + 1;
        this.currentOptionIndex = 0;
      }
    },
    getCategories() {
      var array = [];
      array.push("Seleccione una categoria");
      for (var i = 0; i < this.categories.length; i++) {
        array.push(this.categories[i].name);
      }
      return array;
    },
    onFileSelected(event) {
      this.selectedFile = event.target.files[0];

      const storageRef = firebase
        .storage()
        .ref(
          "/images/" +
            this.product.code +
            "/" +
            this.product.options[this.currentOptionIndex].name +
            "/" +
            this.selectedFile.name
        );
      const task = storageRef.put(this.selectedFile);
      task.on(
        "state_changed",
        (snapshot) => {},
        (error) => {
          console.error(error);
        },
        () => {
          task.snapshot.ref.getDownloadURL().then((url) => {
            if (
              this.product.options[this.currentOptionIndex].images === undefined
            ) {
              this.product.options[this.currentOptionIndex].images = [];
            }
            this.product.options[this.currentOptionIndex].images.push({
              url: url,
            });
          });
        }
      );
    },
    showOption(index) {
      if (this.currentOptionIndex !== index) {
        this.currentOptionIndex = index;
      } else {
        this.currentOptionIndex = -1;
      }
    },
    addOption() {
      this.product.options.push({
        name: "",
        stock: 0,
        price: "",
        images: [],
      });
    },
    removeOption(index) {
      this.product.options.splice(index, 1);
    },
    deleteImage(imgIndex) {
      if (this.product.options[this.currentOptionIndex].images.length > 0) {
        if (imgIndex !== -1) {
          this.product.options[this.currentOptionIndex].images.splice(
            imgIndex,
            1
          );
        }
      }
    },
  },
  components: {
    ButtonComponent,
    Header,
  },
};
</script>

<style scoped>
.container {
  width: 100%;
}
.item-container {
  width: 100%;
  margin: 0px 0px 30px 0px;
}
.header-container {
  background-color: rgba(95, 106, 121, 0.06);
  padding: 15px;
  text-align: center;
  border-radius: 10px;
  border-style: groove;
  display: inline-flex;
  width: 100%;
}
.form-container {
  margin: 15px;
}
.options-container {
  background-color: rgba(95, 106, 121, 0.06);
  border-radius: 15px;
  padding: 0px 0px 0px 0px;
  margin-bottom: 20px;
}
.option-name {
  width: 97%;
  align-self: center;
}
.galery {
  padding: 10px;
}
.image {
  margin: 10px;
  border-style: solid;
}
.header-option {
  width: 100%;
  display: inline-flex;
  cursor: pointer;
}
.remove-option {
  margin-top: 2.5px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/News.vue